import { render } from "./payWithCrypto.vue?vue&type=template&id=62544dba&ts=true"
import script from "./payWithCrypto.vue?vue&type=script&lang=ts"
export * from "./payWithCrypto.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__